module.exports = __webpack_public_path__ + "img/case-bg-3.02213dd7.png";